import worker from './worker'

const workerIn = {}

Object.keys(worker).forEach(key => workerIn[key] = JSON.parse(JSON.stringify(worker[key])))

export default workerIn
